import { useTranslation } from "react-i18next";
import "./passPromoBanner.scss";

// Multi-entry-pass purchase promo — the "4 entries" banner shown to users who
// have no pass but may buy one. Used by the purchase summary; home has its own
// design (PromoPassCard in HomePassBanner.jsx) and Profile its own copy. The
// component owns the look; outer spacing is the caller's (via className on
// the root).
function PassPromoBanner({ passArt, onClick, className }) {
  const { t } = useTranslation();

  return (
    <button type="button" className={`ppb-v2${className ? ` ${className}` : ""}`} onClick={onClick}>
      <div className="ppb-v2-texts">
        <p className="ppb-v2-title">{t("PASS_BANNER_TITLE")}</p>
        <p className="ppb-v2-body">
          {t("PASS_BANNER_BODY")} <span className="ppb-v2-link">{t("PASS_BANNER_LINK")}</span>
        </p>
      </div>
      <img className="ppb-v2-art" src={passArt} alt="" />
    </button>
  );
}

export default PassPromoBanner;
